const OrganizationMemberSSOModeConstants = {
  REQUIRED: "REQUIRED",
  OPTIONAL: "OPTIONAL",
} as const;

export type OrganizationMemberSSOModes =
  (typeof OrganizationMemberSSOModeConstants)[keyof typeof OrganizationMemberSSOModeConstants];

export default OrganizationMemberSSOModeConstants;
